// Section 19 foreshadowing (stream E2): "Half the disasters give a one-season warning with a
// probability, so the player can hedge. Warnings can be false. The report phrases them as
// observations." When next season's draw is made, each foreshadowable event drawn gives a warning
// with its chance (poor harvest 60%, the others config.eventDeck.foreshadowShare); one not drawn
// gives a false warning at `falseWarningShare` of the real rate. The rolls are part of the draw.
import { seasonOfTurn } from '../../core/content-helpers';
import type { EventDraw, PhaseContext } from '../../core/types';
import { deckChance, foreshadowIds } from './deck';

export function foreshadow(ctx: PhaseContext, draw: EventDraw): void {
  const season = seasonOfTurn(ctx, draw.turn + 1);
  foreshadowIds(ctx.registry).forEach((eventId, i) => {
    const chance = ctx.registry.events[eventId].foreshadow?.chance ?? 0;
    const roll = draw.warningRolls[i] ?? 1;
    const real = draw.candidates.some((c) => c.eventId === eventId);
    const falseRate =
      chance *
      deckChance(ctx.cfg, ctx.registry, ctx.state.options, eventId, season) *
      ctx.cfg.eventDeck.falseWarningShare;
    if (roll >= (real ? chance : falseRate)) return;
    ctx.draft.foreshadows.push({
      eventId,
      announcedTurn: ctx.season.turn,
      targetTurn: draw.turn + 1,
      isReal: real,
    });
    ctx.report.add({ kind: 'foreshadow', eventId });
  });
}
